// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../common/temp/default/node_modules/.pnpm/@rsbuild+core@1.1.13/node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 {
  flex-direction: column;
  align-self: stretch;
  width: 155px;
  margin-left: 8px;
  display: flex;
  position: relative;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__pop-container-wUtoh5 {
  align-self: self-start;
  width: 100%;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-type-Nc2Nlr {
  width: 100%;
  height: 24px;
  padding: 0 1px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H {
  flex-shrink: 0;
  justify-content: flex-start;
  align-self: stretch;
  align-items: center;
  width: 86px;
  height: 24px;
  margin-left: 8px;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-no-g8lhDT {
  align-items: center;
  display: flex;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-no-g8lhDT .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-rkdWfT {
  cursor: pointer;
  color: #888d92;
  width: 20px;
  height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-no-g8lhDT .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-rkdWfT.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__disabled-beOtst {
  cursor: not-allowed;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-no-g8lhDT .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-rkdWfT > svg {
  width: 20px;
  height: 20px;
}

.\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4 .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H .\\------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__add-MAirMU {
  color: #4d53e8;
  cursor: pointer;
  margin-left: 8px;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__container-Krz8y4`,
	"pop-container": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__pop-container-wUtoh5`,
	"popContainer": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__pop-container-wUtoh5`,
	"param-type": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-type-Nc2Nlr`,
	"paramType": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-type-Nc2Nlr`,
	"param-operator": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H`,
	"paramOperator": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__param-operator-T8gv4H`,
	"icon-no": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-no-g8lhDT`,
	"iconNo": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-no-g8lhDT`,
	"icon": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__icon-rkdWfT`,
	"disabled": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__disabled-beOtst`,
	"add": `------packages-common-biz-components-src-parameters-components-custom-tree-node-components-param-type-index-module__add-MAirMU`
};
export default ___CSS_LOADER_EXPORT___;
